<template>
  <main class="app-main home-screen">
    <div class="app-content">
      <div class="container-fluid py-4">
        <section class="home-hero">
          <div class="home-hero__content">
            <span class="home-hero__eyebrow">أحمد المحيسني العقارية</span>
            <h1>مرحباً، {{ GET_USER_DATA.userName || 'أهلاً بك' }}</h1>
            <p>خبرة عقارية، رؤية حديثة. تابع الأداء وأنجز أعمالك اليومية من مساحة واحدة واضحة.</p>
            <div class="home-hero__actions">
              <router-link v-if="checkAccess('charts_read')" to="/stats" class="btn home-primary-action">
                عرض لوحة التحكم <i class="bi bi-arrow-left me-2"></i>
              </router-link>
              <router-link to="/properties" class="btn home-secondary-action">
                إدارة العقارات <i class="bi bi-buildings me-2"></i>
              </router-link>
            </div>
          </div>
          <div class="home-hero__brand" aria-hidden="true">
            <div class="home-hero__mark"><img src="/assets/img/brand-mark.svg" alt=""></div>
            <span>نرتقي بخبرتنا… لتسكن بثقة</span>
          </div>
        </section>

        <div class="home-principles">
          <article>
            <span class="home-principles__icon"><i class="bi bi-bar-chart-line"></i></span>
            <div><h2>وضوح المؤشرات</h2><p>قراءة سريعة لأهم أرقام الأعمال.</p></div>
          </article>
          <article>
            <span class="home-principles__icon"><i class="bi bi-check2-circle"></i></span>
            <div><h2>دقة المتابعة</h2><p>حالة الطلبات والخدمات دون تشتيت.</p></div>
          </article>
          <article>
            <span class="home-principles__icon"><i class="bi bi-lightning-charge"></i></span>
            <div><h2>قرارات أسرع</h2><p>كل ما تحتاجه أقرب إلى متناولك.</p></div>
          </article>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { checkAccess } from '@/helpers/tools';

export default {
  name: "HomeView",
  methods: {
    checkAccess,
  },
  computed: {
    ...mapGetters(["GET_USER_DATA"]),
  },
};
</script>

<style scoped>
.home-screen { min-height: calc(100vh - 7rem); }
.home-hero {
  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(260px, .7fr);
  align-items: center;
  min-height: 430px;
  overflow: hidden;
  padding: clamp(34px, 6vw, 76px);
  color: #fff;
  border: 1px solid rgba(166,144,87,.36);
  border-radius: 24px;
  background:
    linear-gradient(122deg, transparent 0 61%, rgba(166,144,87,.09) 61% 69%, transparent 69%),
    linear-gradient(142deg,#3e572e 0%,#2f4525 58%,#1c191a 130%);
  box-shadow: 0 24px 60px rgba(28,25,26,.14);
}
.home-hero::before,
.home-hero::after {
  content: "";
  position: absolute;
  z-index: -1;
  transform: skewX(-35deg);
  border: 1px solid rgba(255,255,255,.055);
  background: rgba(255,255,255,.025);
}
.home-hero::before { inset: 55% -5% -52% 15%; }
.home-hero::after { inset: -62% 44% 58% -10%; }
.home-hero__content { max-width: 650px; }
.home-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: #d8ca9f;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .04em;
}
.home-hero__eyebrow::before { content:""; width: 32px; height: 1px; background: #a69057; }
.home-hero h1 { margin: 0; font-size: clamp(32px,5vw,54px); font-weight: 650; letter-spacing: -.035em; }
.home-hero p { max-width: 590px; margin: 17px 0 28px; color: rgba(255,255,255,.72); font-size: 16px; line-height: 1.9; }
.home-hero__actions { display: flex; flex-wrap: wrap; gap: 10px; }
.home-hero__actions .btn { padding: 10px 18px; }
.home-primary-action { border-color: #a69057; background: #a69057; color: #fff; }
.home-primary-action:hover { border-color: #c2ad73; background: #c2ad73; color: #1c191a; }
.home-secondary-action { border-color: rgba(255,255,255,.24); background: rgba(255,255,255,.07); color: #fff; }
.home-secondary-action:hover { border-color: rgba(255,255,255,.42); background: rgba(255,255,255,.13); color: #fff; }
.home-hero__brand { display: flex; flex-direction: column; align-items: center; gap: 15px; color: rgba(255,255,255,.62); font-size: 11px; }
.home-hero__mark {
  display: grid;
  place-items: center;
  width: 154px;
  height: 154px;
  border: 1px solid rgba(255,255,255,.12);
  border-radius: 50%;
  background: rgba(255,255,255,.95);
  box-shadow: 0 22px 50px rgba(0,0,0,.20);
}
.home-hero__mark img { width: 112px; height: 112px; }
.home-principles { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 14px; margin-top: 18px; }
.home-principles article {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px;
  border: 1px solid rgba(62,87,46,.12);
  border-radius: 15px;
  background: rgba(255,255,255,.9);
  box-shadow: 0 8px 24px rgba(28,25,26,.045);
}
.home-principles__icon { display:grid; place-items:center; width:42px; height:42px; flex:0 0 auto; border-radius:11px; background:#ebf4df; color:#3e572e; font-size:18px; }
.home-principles h2 { margin:0 0 3px; color:#263a20; font-size:14px; font-weight:600; }
.home-principles p { margin:0; color:#7a8276; font-size:11px; }
@media (max-width: 767.98px) {
  .home-hero { grid-template-columns: 1fr; min-height: 0; padding: 32px 24px; }
  .home-hero__brand { display: none; }
  .home-principles { grid-template-columns: 1fr; }
}
</style>
